function DashboardActiveMainTrackStatus( {value} ) {
    const trackStatus = {
        0: "Green",
        1: "Fast",
        2: "Optimum",
        3: "Greasy",
        4: "Damp",
        5: "Wet",
        6: "Flooded",
    }[value["track-grip-status"]] || "Uknown";

    return (
        <div className="mt-auto">
            <div className="rounded bg-[#111a22] p-3 border border-[#324d67] flex items-center justify-between">
                <p className="text-xs font-bold uppercase text-[#92adc9]">Track Grip Status: <span className="text-[#FFF]">{trackStatus}</span></p>
            </div>
        </div>
    );
}

export default DashboardActiveMainTrackStatus;